/*global tinymce, jQuery */

;(function (tinymce, $) {
  'use strict';

  tinymce.PluginManager.add('a51listpaste', function (editor) {
    editor.on('PastePreProcess', function (e) {
      let parent = editor.selection.getNode();

      while (parent && parent.nodeName !== "LI" && parent.nodeName !== "BODY") {
        parent = parent.parentNode;
      }

      if (parent && parent.nodeName === "LI") {
        let content = e.content
          // strip unwanted metadata, styles, list elements...
          .replace(/<meta[^>]*>/gi, "")
          .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "")
          .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, "")
          .replace(/<head[^>]*>[\s\S]*?<\/head>/gi, "")
          .replace(/<ol[^>]*>/gi, "")
          .replace(/<\/ol>/gi, "")
          .replace(/<ul[^>]*>/gi, "")
          .replace(/<\/ul>/gi, "")
          // strip bogus <br>
          .replace(/<br[^>]*data-mce-bogus[^>]*>/gi, "")
          // normalize block tags to newlines
          .replace(/<p[^>]*>/gi, "\n")
          .replace(/<\/p>/gi, "\n")
          .replace(/<div[^>]*>/gi, "\n")
          .replace(/<\/div>/gi, "\n")
          .replace(/<li[^>]*>/gi, "\n")
          .replace(/<\/li>/gi, "\n")
          .replace(/<br\s*\/?>/gi, "\n")
          .replace(/\r\n?/g, "\n");

        const lines = content
          .split("\n")
          .map(line => line.trim())
          .filter(line => line.length > 0);

        if (lines.length > 1) {
          let newContent = "";
          for (const line of lines) {
            newContent += `<li>${line}</li>`;
          }
          e.content = newContent;
        }
      }
    });
  });

})(tinymce, jQuery);
